module.exports = __webpack_public_path__ + "img/hero-houses.4dbdad8c.jpg";